import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { slides } from './slides';
import { useScreenInit } from '../useScreenInit.js';
export function Deck() {
  const screenInit = useScreenInit();
  const [currentIndex, setCurrentIndex] = useState(typeof screenInit?.slide === 'number' ? screenInit.slide : 0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'PageDown') {
        e.preventDefault();
        if (currentIndex < slides.length - 1) {
          setDirection(1);
          setCurrentIndex(prev => prev + 1);
        }
      } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
        e.preventDefault();
        if (currentIndex > 0) {
          setDirection(-1);
          setCurrentIndex(prev => prev - 1);
        }
      } else if (e.key === 'Home') {
        e.preventDefault();
        setDirection(-1);
        setCurrentIndex(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        setDirection(1);
        setCurrentIndex(slides.length - 1);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);
  const goPrev = () => {
    if (currentIndex > 0) {
      setDirection(-1);
      setCurrentIndex(prev => prev - 1);
    }
  };
  const goNext = () => {
    if (currentIndex < slides.length - 1) {
      setDirection(1);
      setCurrentIndex(prev => prev + 1);
    }
  };
  const CurrentSlide = slides[currentIndex];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)]" data-id="element-1">
      <AnimatePresence mode="wait" custom={direction} data-id="element-2">
        <motion.div key={currentIndex} custom={direction} initial={{
        opacity: 0,
        x: direction > 0 ? 40 : -40
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: direction > 0 ? -40 : 40
      }} transition={{
        duration: 0.4,
        ease: [0.4, 0, 0.2, 1]
      }} className="absolute inset-0" data-id="element-3">
          <CurrentSlide index={currentIndex} total={slides.length} data-id="element-4" />
        </motion.div>
      </AnimatePresence>

      {/* Back / Forward buttons */}
      <button onClick={goPrev} disabled={currentIndex === 0} aria-label="Previous slide" className="absolute bottom-7 left-8 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white/90 text-[var(--brand-green)] shadow-sm backdrop-blur transition-all hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-5">
        <ChevronLeft className="h-5 w-5" data-id="element-6" />
      </button>
      <button onClick={goNext} disabled={currentIndex === slides.length - 1} aria-label="Next slide" className="absolute bottom-7 right-8 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white/90 text-[var(--brand-green)] shadow-sm backdrop-blur transition-all hover:bg-white disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-7">
        <ChevronRight className="h-5 w-5" data-id="element-8" />
      </button>

      {/* Progress dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-50" data-id="element-9">
        {slides.map((_, idx) => <button key={idx} onClick={() => {
        setDirection(idx > currentIndex ? 1 : -1);
        setCurrentIndex(idx);
      }} className={`w-2 h-2 rounded-full transition-all ${idx === currentIndex ? 'bg-[var(--brand-green)] w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-10" />)}
      </div>
    </div>;
}